<template>
  <section class="section">
    <modal-promo-code
      v-if="showModal"
      :close="closeModal"
      :action="isEditing ? saveEdit : saveCreate"
      :title="isEditing ? 'Editar código promocional' : 'Crear código promocional'"
      :promo="editingPromo"
    />
    <modal-delete-promo-code
      v-if="showDeleteModal"
      :close="closeDeleteModal"
      :action="confirmDelete"
    />
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title">Códigos promocionales</h1>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="control">
            <input class="input" type="text" v-model="search" @keyup="searchCodes" placeholder="Buscar código...">
          </div>
        </div>
        <div class="level-item">
          <button class="button is-info" @click="openCreateModal">Crear código</button>
        </div>
      </div>
    </nav>
    <div class="columns is-multiline">
      <div class="column is-12">
        <base-table
          class="is-bordered is-striped is-narrow is-fullwidth is-hoverable"
          :columns="promotionCodeColumns"
          :data="promotionCodeList"
          :loading="loading"
        >
          <div slot="video_empresa" slot-scope="scope">
            <input
              type="checkbox"
              :checked="scope.row.video_empresa"
              @change="toggleCheckbox(scope.row, 'video_empresa', $event)"
            >
          </div>
          <div slot="video_actualizado" slot-scope="scope">
            <input
              type="checkbox"
              :checked="scope.row.video_actualizado"
              @change="toggleCheckbox(scope.row, 'video_actualizado', $event)"
            >
          </div>
          <div slot="video_usuarios" slot-scope="scope">
            <input
              type="checkbox"
              :checked="scope.row.video_usuarios"
              @change="toggleCheckbox(scope.row, 'video_usuarios', $event)"
            >
          </div>
          <div slot="actions" slot-scope="scope">
            <em class="material-icons icon-action" @click="openEditModal(scope.row)">edit</em>
            <em class="material-icons icon-action" @click="openDeleteModal(scope.row)">delete</em>
          </div>
        </base-table>
      </div>
    </div>
    <base-pagination
      class="is-medium"
      :page="page"
      :pages="parseInt(pages)"
      :action="paginator"
      :loading="loading"
    />
  </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'PromotionCodes',
  components: {
    BaseTable: () => import('@/components/Table'),
    BasePagination: () => import('@/components/BasePagination'),
    ModalPromoCode: () => import('@/components/Promotions/ModalPromoCode'),
    ModalDeletePromoCode: () => import('@/components/Promotions/ModalDeletePromoCode')
  },
  data () {
    return {
      promotionCodeList: [],
      loading: false,
      page: 1,
      pages: 1,
      search: '',
      showModal: false,
      showDeleteModal: false,
      isEditing: false,
      editingPromo: {},
      deletingPromo: null,
      promotionCodeColumns: [
        {
          id: 'id',
          header: 'ID',
          class: 'column-mobile'
        },
        {
          id: 'code',
          header: 'Código',
          class: 'column-mobile'
        },
        {
          id: 'partner_name',
          header: 'Partner',
          class: 'column-mobile',
          accessor: (row) => row.partner_name || '—'
        },
        {
          id: 'partner_uses_own_prices',
          header: 'Lista propia',
          class: 'column-mobile has-text-centered',
          accessor: (row) => (row.partner_id ? (row.partner_uses_own_prices ? 'Sí' : 'No') : '—')
        },
        {
          id: 'created_at',
          header: 'Creado el',
          class: 'column-mobile',
          accessor: (row) => this.formatDate(row.created_at)
        },
        {
          id: 'start_date',
          header: 'Inicio',
          class: 'column-mobile',
          accessor: (row) => this.formatDate(row.start_date)
        },
        {
          id: 'end_date',
          header: 'Fin',
          class: 'column-mobile',
          accessor: (row) => this.formatDate(row.end_date)
        },
        {
          id: 'is_active',
          header: 'Activo',
          class: 'column-mobile',
          accessor: (row) => (row.is_active ? 'Sí' : 'No')
        },
        {
          id: 'video_empresa',
          name: 'video_empresa',
          header: 'Video Empresa',
          class: 'column-mobile has-text-centered'
        },
        {
          id: 'video_actualizado',
          name: 'video_actualizado',
          header: 'Video Actualizado',
          class: 'column-mobile has-text-centered'
        },
        {
          id: 'video_usuarios',
          name: 'video_usuarios',
          header: 'Video Usuarios',
          class: 'column-mobile has-text-centered'
        },
        {
          id: 'actions',
          name: 'actions',
          header: 'Acciones',
          class: 'column-mobile has-text-centered'
        }
      ]
    }
  },
  methods: {
    ...mapActions(['promoCodeList', 'createPromoCode', 'updatePromoCode', 'deletePromoCode']),
    formatDate (dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      if (isNaN(date)) return ''
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}-${month}-${year}`
    },
    fetchList () {
      this.loading = true
      this.promoCodeList({ page: this.page, search: this.search })
        .then(response => {
          if (response) {
            this.promotionCodeList = response.payload
            this.pages = response.totalPages || 1
          }
        })
        .catch(error => {
          console.error('Error al obtener códigos:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    paginator (newPage) {
      this.page = newPage
      this.fetchList()
    },
    searchCodes ({ target }) {
      if (target.value.length >= 3 || target.value.length === 0) {
        this.page = 1
        this.search = target.value
        this.fetchList()
      }
    },
    openCreateModal () {
      this.isEditing = false
      this.editingPromo = {}
      this.showModal = true
    },
    openEditModal (row) {
      this.isEditing = true
      this.editingPromo = { ...row }
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
      this.editingPromo = {}
    },
    openDeleteModal (row) {
      this.deletingPromo = row
      this.showDeleteModal = true
    },
    closeDeleteModal () {
      this.showDeleteModal = false
      this.deletingPromo = null
    },
    async saveCreate (data) {
      const result = await this.createPromoCode(data)
      if (result && result.success) {
        this.showModal = false
        this.fetchList()
      }
    },
    async saveEdit (data) {
      const result = await this.updatePromoCode({ id: this.editingPromo.id, data })
      if (result && result.success) {
        this.showModal = false
        this.fetchList()
      }
    },
    async confirmDelete () {
      if (!this.deletingPromo) return
      const result = await this.deletePromoCode(this.deletingPromo.id)
      if (result && result.success) {
        this.showDeleteModal = false
        this.deletingPromo = null
        this.fetchList()
      }
    },
    async toggleCheckbox (row, field, event) {
      const value = event.target.checked
      await this.updatePromoCode({ id: row.id, data: { [field]: value } })
      this.fetchList()
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>

<style scoped>
.section {
  width: 100%;
  padding: 0 20px 0 20px;
}
.title {
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 24px;
}
.icon-action {
  cursor: pointer;
  color: #039DA1;
  margin: 0 4px;
}
</style>
